// extracted by mini-css-extract-plugin
export default {"outerBox":"HVLogo_module-NX2CDPYF_outerBox__su8Ng","textStyle":"HVLogo_module-NX2CDPYF_textStyle__fYvkd"};